import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from '../context/AuthProvider';

export type UseAuthResult = AuthContextValue;

export function useAuth(): UseAuthResult {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
